var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "extras" },
    [
      _c("h1", [_vm._v("Add Extras")]),
      _vm._v(" "),
      _vm.getAddonsStatus == "success" && _vm.addons.length == 0
        ? _c("p", [_vm._v("There are no extras available")])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "el-collapse",
        {
          model: {
            value: _vm.activeSections,
            callback: function($$v) {
              _vm.activeSections = $$v
            },
            expression: "activeSections"
          }
        },
        _vm._l(_vm.addons, function(category, i) {
          return _vm.isAddonsUpdated
            ? _c(
                "el-collapse-item",
                { attrs: { title: category.description, name: i } },
                [
                  _c(
                    "el-row",
                    { attrs: { gutter: 20, type: "flex" } },
                    _vm._l(category.price_keys.price_keys, function(addon) {
                      return _c(
                        "el-col",
                        { attrs: { xs: 24, sm: 12, md: 8 } },
                        [
                          _c(
                            "el-card",
                            {
                              attrs: {
                                shadow: "never",
                                "body-style": { padding: "0px" }
                              }
                            },
                            [
                              _c(
                                "div",
                                { attrs: { slot: "header" }, slot: "header" },
                                [
                                  _c("h3", [
                                    _vm._v(
                                      _vm._s(addon.conqueror_pro_price_key_name)
                                    )
                                  ])
                                ]
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "image" }, [
                                _c("img", { attrs: { src: addon.picture_id } })
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "content" },
                                [
                                  _c("div", { staticClass: "description" }, [
                                    _vm._v(_vm._s(addon.description))
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "price" },
                                    [
                                      _c("i18n-n", {
                                        attrs: {
                                          value: +addon.value,
                                          format: "currency"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "el-form",
                                    [
                                      _c("el-input-number", {
                                        attrs: {
                                          value:
                                            _vm.booking.options.addons[addon.id]
                                              .qty,
                                          min: 0,
                                          max: 30,
                                          size: _vm.formSize
                                        },
                                        on: {
                                          input: function($event) {
                                            return _vm.setAddon($event, addon)
                                          }
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ]
                          )
                        ],
                        1
                      )
                    }),
                    1
                  )
                ],
                1
              )
            : _vm._e()
        }),
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }